import { SelectItem } from '@mantine/core/lib/Select/types';
import { CopyTranslations, FinancialTerms } from 'localization/localization-types';

const CANDADA_FINANCIAL_TERMS_COPY: FinancialTerms = {
  preTaxPrice: 'Pre tax price',
  pretax: 'Pre-Tax',
  subtotal: 'Subtotal',
  tax: 'Tax',
  taxRate: 'Tax Rate',
};

export const CANDADA_COPY: CopyTranslations = {
  financial: CANDADA_FINANCIAL_TERMS_COPY,
  address: {
    zipLabel: 'Postal Code',
    zipPlaceholder: 'Enter Postal Code',
    zipInputMask: 'a9a 9a9',
    regionLabel: 'Province/Territory',
    regionPlaceholder: 'Select province or territory',
  },
  components: {
    MoneyField: {
      priceInputLabel: 'Pre tax price',
      priceInputPlaceholder: 'Set pre tax price',
    },
    AthletePackageDetail: {
      InvoicesTab: {
        packageBillingPlanInstallmentsThirdColumn: 'Installments (Pre-Tax)',
        packageBillingPlanTotalPricePreTaxFirstColumn: 'Total Price (Pre-Tax)',
      },
    },
    AthletePackageCreateForm: {
      invoicesSummaryTitle: 'Invoices (Pre-Tax)',
    },
  },
};

export const CANADA_PROVINCES_TERRITORIES: SelectItem[] = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' },
];
